import React, { useEffect } from "react";
import styles from "../shoabAndOffice/style.module.css";
import style from "../../../account/style.module.css";
import { getApiShoab } from "../../../../../redux/shoab/shoab/action/getApiShoab";
import { useDispatch } from "react-redux";

const ShoabContent = ({ filterShoab, apiShoab, CityName, CityName1 }) => {
  // console.log("apiShoab", apiShoab);
  const dispatch = useDispatch();
console.log("apiShoab",apiShoab);
  let searchFilter = apiShoab.filter(
    (itm) =>
    
      CityName1.length !== 0
        ? itm.cityName?.includes(CityName1)
        : CityName?.length !== 0
        ? itm.cityName?.includes(CityName) ||
          itm.cityCodePhoneNumber.includes(CityName) ||
          itm.phoneNumber?.includes(CityName) ||
          itm.province?.includes(CityName)
        : !itm.province?.includes("تهران")
    
    // itm.body.Address.includes(CityName1)
  );

  // useEffect(() => {
  //   searchFilter = apiOffice.filter(
  //     (itm) =>
  //       itm.body.CityName.includes(CityName1) ||
  //       itm.body.Address.includes(CityName1)
  //   );
  // }, [CityName1]);
  useEffect(() => {
    if (filterShoab === "shoab") {
      dispatch(getApiShoab());
    }
  }, [filterShoab]); //eslint-disable-line react-hooks/exhaustive-deps
  return (
    <>
      <div className={styles.sectionContent}>
        <div className="container text-right">
          <div className="table-responsive mb-5">
            <table className={`${style.tableParent + " table"}`}>
              <tr>
                <th>استان</th>
                <th>شهر</th>
                <th>مسئول</th>
                <th>آدرس</th>
                <th>تلفن</th>
                <th>پیش شماره</th>
                <th>نقشه</th>
              </tr>
              {searchFilter.map((item, index) => (
                <tr key={index}>
                  <td>{item.province}</td>
                  <td>{item.cityName}</td>
                  <td>{item.directorEmployee}</td>
                  <td>
                    <p style={{ width: "500px" }}>{item.address}</p>
                  </td>
                  <td>{item.phoneNumber}</td>
                  <td>{item.cityCodePhoneNumber }</td>
                  <td><a href={item.googleMapUrl } target="_blank">
                  <img
                        src={"/asset/images/Path 68.png"}
                        alt=""
                        className="ml-1"
                      />
                  </a>
                    
                  </td>
                </tr>
              ))}
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default ShoabContent;
